import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import formatTimeSince from '../../utils/formatTimeSince';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';
import { AppI18n } from '../../../i18n/i18n';
import { NumberOfResponses } from './NumberOfResponses';

interface BriefHeaderProps {
  title: SellerBriefResponse['title'];
  createdAt?: SellerBriefResponse['createdAt'];
  totalCount?: SellerBriefResponse['customOffersMetrics']['totalCount'];
  isEdited?: boolean;
  isSeller?: boolean;
  actionsMenu?: ReactNode;
}

export const BriefHeader: React.FC<BriefHeaderProps> = ({
  title,
  createdAt,
  totalCount,
  isSeller,
  isEdited,
  actionsMenu,
}) => (
  <Stack direction="column" gap="2">
    <Stack direction="row" justifyContent="spaceBetween" alignItems="flexStart">
      <Heading size={{ default: 'h_md', sm: 'h_lg' }}>{title}</Heading>
      {actionsMenu}
    </Stack>
    {isSeller ? (
      <Stack
        dividerProps={{
          variant: 'dot',
        }}
        color="grey_1000"
        withDivider
        gap="2"
        wrap="wrap"
      >
        {isEdited && (
          <Text size="b_md" color="bodySecondary">
            <AppI18n k="edited_brief" />
          </Text>
        )}
        {createdAt && (
          <Text size="b_md" color="bodySecondary">
            {formatTimeSince(createdAt)}
          </Text>
        )}
        {totalCount !== undefined && <NumberOfResponses totalCount={totalCount} />}
      </Stack>
    ) : (
      <Stack
        dividerProps={{
          variant: 'dot',
        }}
        color="grey_1000"
        withDivider
        gap="2"
        wrap="wrap"
      >
        {isEdited && (
          <Text size="b_md" color="bodySecondary">
            <AppI18n k="edited_brief_indication" />
          </Text>
        )}
      </Stack>
    )}
  </Stack>
);
